import type React from 'react';
import type { IconProps } from 'types/icon';

type SvgIconProps = Omit<IconProps, 'children'> & {
  viewBox?: string;
  children: (color: string) => React.ReactNode;
};

export const SvgIcon: React.FC<SvgIconProps> = ({
  size = '24',
  color = 'currentColor',
  viewBox = '0 0 24 24',
  children,
  ...attributes
}) => (
  <svg
    width={size}
    height={size}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...attributes}
  >
    {children(color)}
  </svg>
);
